const ENDPOINT = process.env.REACT_APP_ENDPOINT

async function incrementPuzzPlayed(puzzleId) {
    let apiUrl = ENDPOINT
    apiUrl += `/snake/increment_plays/?id=${puzzleId}`;
    try {
        const response = await fetch(apiUrl,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        if (data.error) {
            throw new Error(data.error);
        }
        return data;
    } catch (error) {
        console.error('There was a problem with incrementPuzzPlayed:', error);
        return [];
    }
}

export default incrementPuzzPlayed;